import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const entorno = createAsyncThunk(
    'entorno/getEntorno',
    async () => {
        try {
            const request = await axios.get("/api/sensor/getEntorno")
            return request.data
        } catch (error) {
            throw error
        }
    }
)




